import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { default as ReactSelect } from 'react-select'

const SelectWrapper = styled.div`
  width: 100%;
  margin: 0 0 30px 0;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: ${props => (props.paddingBottom ? props.paddingBottom : '0px')};
  & > div > div:first-child {
    background-color: #fbf8f1 !important;
    border: none !important;
    border-radius: 10px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16) !important;
    min-height: 41px;
  }

  .css-11unzgr {
    padding: 0 !important;
  }
  .css-1bd67wx {
    color: #fff !important;
  }
  .css-1khxe72 {
    background-color: #fbf8f1 !important;
    border-radius: 100px !important;
    border: none !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16) !important;
  }
  .css-k136fc {
    border-radius: 100px !important;
    background-color: #fbf8f1 !important;
    min-height: 41px;
  }
  .css-15k3avv {
    background-color: #fbf8f1 !important;
  }
  .css-1ep9fjw {
    padding: 10px 14px !important;
  }
  .css-1hwfws3 {
    padding: 2px 18px !important;
  }
`

const MySelectCheckbox = props => {
  if (props.allowSelectAll) {
    return (
      <SelectWrapper>
        <ReactSelect
          {...props}
          options={[props.allOption, ...props.options]}
          onChange={selected => {
            if (
              selected !== null &&
              selected.length > 0 &&
              selected[selected.length - 1].value === props.allOption.value
            ) {
              return props.onChange(props.options)
            }
            return props.onChange(selected)
          }}
        />
      </SelectWrapper>
    )
  }

  return <ReactSelect {...props} />
}

MySelectCheckbox.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
}

MySelectCheckbox.defaultProps = {
  allOption: {
    label: 'Select all',
    value: '*'
  }
}

export default MySelectCheckbox



// WEBPACK FOOTER //
// ./src/components/MySelectCheckbox.js